import { useQuery } from '@apollo/client';

import type { EntityType } from 'bundles/unified-seo-content-common/types';
import { getDeferToCSRQueryOptions } from 'bundles/unified-seo-content-common/utils';
import type {
  EntityQueryConfigs,
  EntityQueryData,
  EntityQueryVariables,
} from 'bundles/unified-seo-content-common/utils/entityCardDataQueryUtils';

const useEntityCardData = <T extends EntityType>({ query, queryOptions, dataResolver }: EntityQueryConfigs<T>) => {
  const { data, loading, error } = useQuery<EntityQueryData<T>, EntityQueryVariables<T>>(query, {
    ...queryOptions,
    ...getDeferToCSRQueryOptions(),
  });

  if (error && !data) {
    return {
      data: undefined,
      loading,
    };
  }

  return {
    ...dataResolver(data),
    loading,
  };
};

export default useEntityCardData;
